const delayAwait = async (start: number, minDelay: number): Promise<boolean> =>
  new Promise((resolve) => {
    const timePassed = Date.now() - start;
    const timeToWait = minDelay - timePassed;
    if (timeToWait < 0) {
      return resolve(true);
    }
    setTimeout(() => {
      resolve(true);
    }, timeToWait);
  });

export default delayAwait;
